import {
  getAnnualIncomeList,
  getMonthlyCaseList,
  getMonthlyDrugList,
  getMonthlyExpenseList,
  getMonthlyIncomeList,
  getStatisticalScope,
  getTotalCaseList,
  getTotalDrugList,
  getTotalExpenseList,
  getTotalIncomeList,
  exportMonthlyIncomeDetail,
  exportTotalIncomeDetail,
  exportMonthlyDrugDetail,
  exportTotalDrugDetail,
  exportMonthlyCaseDetail,
  exportTotalCaseDetail,
  exportMonthlyExpenseDetail,
  exportTotalExpenseDetail,
  exportAnnualIncomeDetail,
} from '../services';

export default {
  namespace: 'medicalIncomeAnalysis',
  state: {},
  effects: {
    // 收入明细分析（单月）
    *getMonthlyIncomeList({ payload }, { call }) {
      return yield call(getMonthlyIncomeList, payload);
    },

    // 收入明细分析（累计）
    *getTotalIncomeList({ payload }, { call }) {
      return yield call(getTotalIncomeList, payload);
    },

    // 药品指标分析（单月）
    *getMonthlyDrugList({ payload }, { call }) {
      return yield call(getMonthlyDrugList, payload);
    },

    // 药品指标分析（累计）
    *getTotalDrugList({ payload }, { call }) {
      return yield call(getTotalDrugList, payload);
    },

    // 病案指标分析（单月）
    *getMonthlyCaseList({ payload }, { call }) {
      return yield call(getMonthlyCaseList, payload);
    },

    // 病案指标分析（累计）
    *getTotalCaseList({ payload }, { call }) {
      return yield call(getTotalCaseList, payload);
    },

    // 均次费用分析（单月）
    *getMonthlyExpenseList({ payload }, { call }) {
      return yield call(getMonthlyExpenseList, payload);
    },

    // 均次费用分析（累计）
    *getTotalExpenseList({ payload }, { call }) {
      return yield call(getTotalExpenseList, payload);
    },

    // 历年收入分析
    *getAnnualIncomeList({ payload }, { call }) {
      return yield call(getAnnualIncomeList, payload);
    },

    // 收入分析统计范围查询
    *getStatisticalScope({ payload }, { call }) {
      return yield call(getStatisticalScope, payload);
    },

    // 收入明细分析（单月）导出
    *exportMonthlyIncomeDetail({ payload }, { call }) {
      return yield call(exportMonthlyIncomeDetail, payload);
    },

    // 收入明细分析（累计）导出
    *exportTotalIncomeDetail({ payload }, { call }) {
      return yield call(exportTotalIncomeDetail, payload);
    },

    // 药品指标分析（单月）导出
    *exportMonthlyDrugDetail({ payload }, { call }) {
      return yield call(exportMonthlyDrugDetail, payload);
    },

    // 药品指标分析（累计）导出
    *exportTotalDrugDetail({ payload }, { call }) {
      return yield call(exportTotalDrugDetail, payload);
    },

    // 病案指标分析（单月）导出
    *exportMonthlyCaseDetail({ payload }, { call }) {
      return yield call(exportMonthlyCaseDetail, payload);
    },

    // 病案指标分析（累计）导出
    *exportTotalCaseDetail({ payload }, { call }) {
      return yield call(exportTotalCaseDetail, payload);
    },

    // 均次费用分析（单月）导出
    *exportMonthlyExpenseDetail({ payload }, { call }) {
      return yield call(exportMonthlyExpenseDetail, payload);
    },

    // 均次费用分析（累计）导出
    *exportTotalExpenseDetail({ payload }, { call }) {
      return yield call(exportTotalExpenseDetail, payload);
    },

    // 历年收入分析导出
    *exportAnnualIncomeDetail({ payload }, { call }) {
      return yield call(exportAnnualIncomeDetail, payload);
    },
  },
};
